<template>
    <div>
        <!-- IP监控 -->
        <a-table id="ipTableID" :columns="columns" :data-source="tableData" :pagination="false" :loading="tloading" rowKey="id">
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
    </div>
</template>
<script>
let pagination = {
    page: 1,
    pageSize: 10,
    total: 0,
}

const columns = [
    {
        title: '客户公网IP',
        dataIndex: 'ip',
        align: 'center',
        width: 120,
    },
    {
        title: '节点IP',
        dataIndex: 'serveip',
        align: 'center',
        width: 120,
    },
    {
        title: '统计时长（总计）',
        dataIndex: 'duration',
        align: 'center',
        width: 120,
    },
    {
        title: '错误解码次数（总计）',
        dataIndex: 'decodeerrorcount',
        align: 'center',
        width: 100,
    },
    {
        title: '处理字节数大小（总计）(BYTES)',
        dataIndex: 'handledbytes',
        align: 'center',
        width: 100,
    },
    {
        title: '处理包耗时（总计）(ms)',
        dataIndex: 'handledpacketcosts',
        align: 'center',
        width: 100,
    },
    {
        title: '接收字节数量（总计）(BYTES)',
        dataIndex: 'receivedbytes',
        align: 'center',
        width: 100,
    },
    {
        title: '接收包数量（总计）',
        dataIndex: 'receivedpackets',
        align: 'center',
        width: 100,
    },
    {
        title: '接收TCP数量（总计）',
        dataIndex: 'receivedtcps',
        align: 'center',
        width: 100,
    },
    {
        title: '建连次数（总计）',
        dataIndex: 'requestcount',
        align: 'center',
        width: 100,
    },
    {
        title: '发送字节数量（总计）(BYTES)',
        dataIndex: 'sentbytes',
        align: 'center',
        width: 100,
    },
    {
        title: '发送包数量（总计）',
        dataIndex: 'sentpackets',
        align: 'center',
        width: 100,
    },
    {
        title: '统计开始时间',
        dataIndex: 'createtime',
        align: 'center',
        width: 100,
    },
    {
        title: '统计最新时间',
        dataIndex: 'updatetime',
        align: 'center',
        width: 100,
    },
    {
        title: '黑白名单',
        dataIndex: 'isblack',
        align: 'center',
        width: 100,
    }
]

export default {
    data() {
        return {
            columns,
            tableData: [],
            tloading: false,
            pagination,
            clientWidth: 800,
            searchP: {},
        }
    },
    methods: {
        handlePageChange(v) {
            this.pagination.page = v
            this.getIpSumData()
        },
        getIpSumData() {
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'mcmsmanager/queryWebsocketoIpstatPageList',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        this.tableData = result.list
                        this.pagination.total = parseInt(result.totalRecords)
                        this.pagination.pageSize = parseInt(result.pageSize)
                        this.pagination.page = parseInt(result.page)
                    }
                    that.tloading = false
                })
                .catch(() => {
                    that.tloading = false
                })
        },
        handleSearch(searchP) {
            this.searchP = searchP
            this.pagination.page = 1
            this.getIpSumData()
        },
    },
    components: {},
    mounted() {},
}
</script>
<style scoped>
.trend_pagination {
    margin-top: 10px;
}

.tableLink {
    margin-right: 10px;
}
</style>

